import React from "react";
import { Route, Routes } from "react-router-dom";
import Cart from "../Pages/Cart";
import DashBoard from "../Pages/DashBoard";
import { Home } from "../Pages/Home";
import { MensProductPage } from "../Pages/MensProductPage";
import { WomensProductPage } from "../Pages/WomensProductPage";
import ManageProduct from "../Pages/ManageProduct";
import ProductDetails from "../Pages/ProductDetails";
import TrackOrder from "../Pages/TrackOrder";
import AddProducts from "../Pages/AddProduct";
import Payment from "../Components/Payment";
import Ordered from "../Pages/Ordered";
import UserOrder from "../Pages/UserOrder";
import PrivateRoute from "./PrivateRoutes";
const AllRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />

        {/* <Route path="/dashboard" element={<DashBoard />} /> */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashBoard />
            </PrivateRoute>
          }
        />

        {/* <Route path="/addProduct" element={<AddProducts />} /> */}
        <Route
          path="/addProduct"
          element={
            <PrivateRoute>
              <AddProducts />
            </PrivateRoute>
          }
        />

        <Route path="/mensAllCloth" element={<MensProductPage />} />
        <Route path="/womensAllCloth" element={<WomensProductPage />} />

        {/* <Route path="/manageProduct" element={<ManageProduct />} /> */}
        <Route
          path="/manageProduct"
          element={
            <PrivateRoute>
              <ManageProduct />
            </PrivateRoute>
          }
        />

        <Route path="/userorders" element={<UserOrder />} />

        {/* <Route path="/trackOrder" element={<TrackOrder />} /> */}
        <Route
          path="/trackOrder"
          element={
            <PrivateRoute>
              <TrackOrder />
            </PrivateRoute>
          }
        />

        {/* <Route path="/ordered" element={<Ordered />} /> */}
        <Route
          path="/ordered"
          element={
            <PrivateRoute>
              <Ordered />
            </PrivateRoute>
          }
        />

        <Route path="/productDetails/:id" element={<ProductDetails />} />
        <Route
          path="womensAllCloth/productDetails/:id"
          element={<ProductDetails />}
        />
        <Route
          path="mensAllCloth/productDetails/:id"
          element={<ProductDetails />}
        />
        <Route
          path="/cart"
          element={
            <PrivateRoute>
              <Cart />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default AllRoutes;
